<template>
  <v-row v-if="sdaData && !onlyShowSDAInv">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <div class="text-subtitle-1">
            Προς: {{ sdaData.client.PartnerBrandName }}
          </div>
          <div class="text-subtitle-2">
            {{ sdaData.client.BranchAddress }}
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SDAClientInfo',
  props: {
    sdaData: {
      type: Object,
      default: null
    },
    onlyShowSDAInv: {
      type: Boolean,
      default: false
    }
  }
}
</script> 